import store from './store';
import { 
	toggleDoctor,
	toggleButtonBack,
	removeQuizResult,
	toggleLabel,
	setQuizStarted,
	setQuizProgress,
	toggleButtonToCommon
} from './reducers/quiz/quiz.actions';
import { resetError } from './reducers/main/main.actions';
import { 	toggleProgress } from './reducers/main/main.actions';
import { addState, rollBackState, setState } from './reducers/history/history.actions';
import { State } from './reducers/history/interfaces/state.interface';
import { StateType } from './reducers/history/enums/state-type.enum';
import { EVENT_START_QUIZ, EVENT_RICH_QUESTION} from './constants';
import { emitEvent } from './event-emitter';
import { ecommerce } from './ecommerce.module';

var animConfig = {active: true, reverse: false};
var switcherIsDisabled = false;
var stack = store.getState().history.stack;
const dispatch = store.dispatch;

const expertViewConfig:{[key in StateType]:boolean} = {
	[StateType.INITIAL]: false,
	[StateType.QUESTIONS]: true,
	[StateType.FORM]: true,
	[StateType.RESULT]: true,
	[StateType.FINAL]: true,
	[StateType.SIGN_UP]: false,
	[StateType.SELECTION]: false,
	[StateType.CALL_TIME]: true,
	[StateType.NULL]: false
}
const progressViewConfig = Object.assign({}, expertViewConfig);

const toggle = (action:object, reverse:boolean):Promise<void> => {
	switcherIsDisabled = true;
	animConfig = {active: false, reverse};
	return new Promise(resolve => {
		setTimeout(() => {
			animConfig = {active: true, reverse};
			dispatch(action);
			stack = store.getState().history.stack;
			switcherIsDisabled = false;
			resolve();
		}, 600);
	});
}

const moveTo = (state:State, callback?:Function):any => {
	if (switcherIsDisabled) return;

	dispatch(setQuizProgress(countQuizProgress(state)));

	if (!store.getState().quiz.started && state.type == StateType.QUESTIONS) {
		dispatch(setQuizStarted(true));
		emitEvent(EVENT_START_QUIZ);
	}

	toggle(addState(state), false).then(() => {
		dispatch(toggleDoctor(expertViewConfig[state.type]));
		dispatch(toggleButtonBack(state.type < StateType.FORM));
		dispatch(toggleButtonToCommon(state.type < StateType.FORM && state.type != StateType.SELECTION))
		dispatch(toggleLabel(state.type != StateType.FORM));
		dispatch(toggleProgress(progressViewConfig[state?.type || 0]));
		dispatch(setQuizProgress(countQuizProgress(state)));

		if (state.type == StateType.QUESTIONS) emitEvent(EVENT_RICH_QUESTION, {question: (state.data?.order)});

		callback && callback();
	});
}

const back = () => {
	if (switcherIsDisabled) return;
	const state = stack[Math.max(stack.length - 1, 0)];

  ecommerce.removeLast();

	dispatch(resetError());
	dispatch(toggleProgress(progressViewConfig[state?.type || StateType.INITIAL]));
	dispatch(toggleButtonBack(stack.length > 1));
	dispatch(toggleButtonToCommon(stack.length > 1 && state.type != StateType.SELECTION))
	dispatch(toggleLabel(state?.type != StateType.FORM));
	dispatch(toggleDoctor(expertViewConfig[state?.type]));
	dispatch(setQuizProgress(countQuizProgress(state)));
	if (state?.type == StateType.QUESTIONS) dispatch(removeQuizResult(state.data?.id));
	toggle(rollBackState(), true);
}

const set = (state:State):void => {
	const {currentState} = store.getState().history;

	if (state.type == currentState.type && (currentState.data ? currentState.data.id == state?.data?.id : false)) {
		return;
	}

	dispatch(setState(state));
	dispatch(toggleProgress(progressViewConfig[state.type]));
	dispatch(toggleButtonBack(false));
	dispatch(toggleButtonToCommon(stack.length > 1 && state.type != StateType.SELECTION))
	dispatch(toggleDoctor(expertViewConfig[state.type]));
	dispatch(setQuizProgress(countQuizProgress(state)));
}

function countQuizProgress(currentState:State) {
	let value = 0;
	const total = store.getState().quiz.questions.length + 1;

	switch(currentState?.type) {
		case StateType.INITIAL: value = 0; break;
		case StateType.QUESTIONS: {
			value = Math.round(100 / total * (currentState.data?.order ?? 1));
			break;
		}
		case StateType.FORM: case StateType.CALL_TIME: value = 99; break;
		case StateType.RESULT: case StateType.FINAL: value = 100; break;
		default: break;
	}

	return value;
}

export { moveTo, back, set, animConfig };